import React from 'react'

const SvgChecklistFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 4a2 2 0 012-2h16a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V4zm8.53 9.22a.75.75 0 010 1.06l-2.396 2.397a.757.757 0 01-1.07 0L5.72 15.333a.75.75 0 011.06-1.06l.819.818 1.87-1.871a.75.75 0 011.061 0zm2.22 1.03a.75.75 0 000 1.5h5a.75.75 0 000-1.5h-5zm-2.22-6.78a.75.75 0 010 1.06l-2.396 2.397a.757.757 0 01-1.07 0L5.72 9.583a.75.75 0 011.06-1.06l.819.818 1.87-1.871a.75.75 0 011.061 0zm2.22 1.03a.75.75 0 000 1.5h5a.75.75 0 000-1.5h-5z'
    />
  </svg>
)

export default SvgChecklistFilled
